module.exports = __webpack_public_path__ + "static/board-20-9557e890ad5a3dd8ab93d7417e86bffd.jpg";